module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "advantage-addition-wrapper"
  }, [_c('div', {
    staticClass: "advantage-addition"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteInvestmentAdvantage(_vm.advantage.id)
      }
    }
  }), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок"
    },
    on: {
      "change": function($event) {
        return _vm.updateInvestmentAdvantage(_vm.advantage)
      }
    },
    model: {
      value: (_vm.advantage.title),
      callback: function($$v) {
        _vm.$set(_vm.advantage, "title", $$v)
      },
      expression: "advantage.title"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Текст",
      "type": "textarea"
    },
    on: {
      "change": function($event) {
        return _vm.updateInvestmentAdvantage(_vm.advantage)
      }
    },
    model: {
      value: (_vm.advantage.description),
      callback: function($$v) {
        _vm.$set(_vm.advantage, "description", $$v)
      },
      expression: "advantage.description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "learn-more"
  }, [_c('b-field', {
    staticClass: "learn-more-field"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок",
      "required": ""
    },
    model: {
      value: (_vm.advantage.learnMoreButton.title),
      callback: function($$v) {
        _vm.$set(_vm.advantage.learnMoreButton, "title", $$v)
      },
      expression: "advantage.learnMoreButton.title"
    }
  }), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "Ссылка",
      "required": ""
    },
    model: {
      value: (_vm.advantage.learnMoreButton.url),
      callback: function($$v) {
        _vm.$set(_vm.advantage.learnMoreButton, "url", $$v)
      },
      expression: "advantage.learnMoreButton.url"
    }
  })], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d63a7f7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndividualInvestment/InvestmentAdvantage.vue
// module id = 905
// module chunks = 0